// extracted by mini-css-extract-plugin
export var alertIcon = "_na-0";